import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { StyleSheet, Text, View, StatusBar } from "react-native";
import { fetchApi } from "../api";
import { STYLES } from "../assets/styles";
import Logo from "../common/Logo";
import CustomButton from "./CustomButton";
import CustomIcon from "./CustomIcon";
import Loading from "./Loading";
import OneTimeCode from "./OneTimeCode";

function AccountVerification({
  userId,
  onSuccess = () => {},
  onClose = () => {},
}) {
  const [sent, setSent] = useState(false);
  const [resend, setResend] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState("02:00");
  const userCode = useRef(null);
  const interval = useRef(null);

  useEffect(() => {
    StatusBar.setBarStyle("dark-content");
    return () => {
      StatusBar.setBarStyle("light-content");
    };
  }, []);

  const requestVerificationCode = () => {
    fetchApi({ path: `/verify/${userId}` }).then((res) => {
      if (res.code) {
        userCode.current = res.code;
        setSent(true);
        setResend(false);
        startTimer();
      }
    });
  };

  const handleCodeCheck = (error, success) => {
    setLoading(true);
    if (error) {
      setError(error.error);
      setLoading(false);
    } else {
      fetchApi({ path: `/verify/${userId}`, method: "POST" }).then((res) => {
        setLoading(false);
        if (!res.error) {
          onSuccess("success");
        } else {
          setError(res.error_description);
        }
      });
    }
  };

  const startTimer = () => {
    let start = moment("02:00", "mm:ss");
    let seconds = start.minutes() * 60;
    interval.current = setInterval(() => {
      let timerDisplay = start.subtract(1, "second").format("mm:ss");
      setTimer(timerDisplay);
      seconds--;
      if (seconds === 0) {
        clearInterval(interval.current);
        setResend(true);
      }
    }, 1000);
  };

  useEffect(() => {
    requestVerificationCode();
    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, [userId]);

  return (
    <View style={{ flex: 1, backgroundColor: STYLES.colors.white }}>
      <View
        style={{
          padding: 10,
          paddingTop: StatusBar.currentHeight,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <CustomIcon
          type="AntDesign"
          name="left"
          onPress={onClose}
          style={{
            fontSize: STYLES.fontSizes.xlarge,
            color: STYLES.colors.black,
          }}
        />
      </View>
      <View style={styles.container}>
        <View
          style={{
            width: "90%",
            padding: 20,
          }}
        >
          <Logo color={STYLES.colors.black} />
          <Text
            style={{
              color: STYLES.colors.black,
              fontSize: STYLES.fontSizes.xxlarge,
              marginVertical: 15,
            }}
          >
            {"Enter the code to \nverify your account"}
          </Text>
          <Text
            style={{
              color: STYLES.colors.black,
              fontSize: STYLES.fontSizes.medium,
            }}
          >
            {`${
              sent ? "we have sent" : "we are sending"
            } you an email with a code to your registered email id.`}
          </Text>
          {sent ? (
            <Text style={{ fontSize: STYLES.fontSizes.small, color: "grey" }}>
              If you did not get the mail, please make sure you have given the
              correct mail id.
            </Text>
          ) : null}
          <OneTimeCode checkCode={userCode.current} onFill={handleCodeCheck} />
          {error ? (
            <Text
              style={{
                fontSize: STYLES.fontSizes.small,
                color: STYLES.colors.tomato,
                textAlign: "center",
              }}
            >
              {error}
            </Text>
          ) : null}
          <View
            style={{
              marginVertical: 10,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                fontSize: STYLES.fontSizes.small,
                color: resend ? "grey" : STYLES.colors.purpel,
              }}
            >
              {timer}
            </Text>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text style={{ fontSize: STYLES.fontSizes.small }}>send new</Text>
              <CustomButton
                onPress={() => {
                  setSent(false);
                  requestVerificationCode();
                }}
                text="code again"
                disabled={!resend}
                transparent
                btnStyle={{
                  paddingHorizontal: 5,
                }}
                textStyle={{
                  color: resend ? STYLES.colors.purpel : "grey",
                  fontSize: STYLES.fontSizes.small,
                  margin: 0,
                }}
              />
              <Text>?</Text>
            </View>
          </View>
        </View>
      </View>
      {loading ? <Loading spinner /> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default AccountVerification;
